import { STATE_TO_AREAS } from "../dealList/constants/malaysiaLocations";
import { ALL_CATEGORIES } from "../dealList/constants";

/**
 * Area wheel: state-level names match `/deals` area filter; first row is anywhere.
 */
export const EXPLORE_AREA_ITEMS = [
  { id: "any", label: "Anywhere", area: "" },
  ...Object.keys(STATE_TO_AREAS)
    .sort((a, b) => a.localeCompare(b))
    .map((state) => ({
      id: state,
      label: state,
      area: state,
    })),
];

const categoryWheelId = (value) =>
  value.replace(/\s+/g, "_").toLowerCase();

/** Home hero left scroller — same options as Filter → Category (`ALL_CATEGORIES`). */
export const EXPLORE_CUISINE_ITEMS = [
  { id: "any", label: "✨ All", category: "", cuisine: "" },
  ...ALL_CATEGORIES.map((cat) => ({
    id: categoryWheelId(cat.value),
    label: cat.label,
    category: cat.filterType === "category" ? cat.value : "",
    cuisine: cat.filterType === "cuisine" ? cat.value : "",
  })),
];

/** Price wheel — `band` is sent as `price_band` on `/deals` (server whitelist). Under RM15 is 3rd. */
export const EXPLORE_PRICE_ITEMS = [
  { id: "any", label: "Any price", band: "any" },
  { id: "under_25", label: "Under RM25", band: "under_25" },
  { id: "under_15", label: "Under RM15", band: "under_15" },
  {
    id: "gte_25",
    label: "B1F1",
    band: "any",
    discountType: "bxfy",
  },
  {
    id: "%_off",
    label: "% OFF",
    band: "any",
    discountType: "percentage",
  },
];

export const HOME_DEFAULT_CUISINE_ID = categoryWheelId("food");

export const HOME_DEFAULT_PRICE_ID = "any";

export const EXPLORE_WHEEL_ITEM_HEIGHT_PX = 48;
export const EXPLORE_WHEEL_VISIBLE_ROWS = 5;
